const fractionDelimiter = ',';
const digitFormatterRegexp = /\d(?=(\d{3})+(,|$))/g;
const digitSectionDelimiter = '$& ';
export const pipe = (...ops) => ops.reduce((a, b) => arg => b(a(arg)));
export const empty = (str) => str.length === 0;
export const trimmer = (str) => str.trim();
export const toNumber = (str) => (empty(str) ? NaN : parseFloat(str));
export const normalizeNumber = str => str.replace(/,,|\.\.|\.,|,\.|,/, '.').replace(/[^-.|\d]/g, '');
export const normalizeNumberUsd = str => normalizeNumber(str.replace(/[,,|,]/g, ''));
export const takeUntill = (amount) => str => str.length <= amount ? str : str.slice(0, amount);
export const formatNumber = (digitFraction) => str => {
    const [digit, fraction] = str.split('.');
    const base = digit.replace(digitFormatterRegexp, digitSectionDelimiter);
    const fractional = digitFraction && fraction !== undefined ? fractionDelimiter + fraction.slice(0, digitFraction) : '';
    return base + fractional;
};
export const applyMaxLimit = (limit) => str => {
    const point = str[str.length - 1] == '.' ? '.' : '';
    const prepared = toNumber(str);
    const result = prepared <= limit ? prepared + point : limit;
    return str ? result.toString() : str;
};
export const fractionTakeUntill = (amount) => str => {
    const [digit, fraction] = str.split('.');
    return fraction ? [digit, takeUntill(amount)(fraction)].join('.') : str;
};
export function toString(value) {
    let result = value;
    if (typeof value === 'number') {
        result = String(value);
    }
    if ((typeof value === 'number' && isNaN(value)) || value === null || typeof value === 'undefined') {
        result = '';
    }
    return result;
}
export const clearCountryPrefix = str => {
    return str.length >= 11 ? str.replace(/^\+*[78](\d)/, '$1') : str;
};
export const clearFormatting = str => str.replace(/\D/g, '');
//# sourceMappingURL=transformation.js.map